import React, { useEffect, useState } from 'react';
import { Row, Col, Form, Select, Button, Popconfirm } from 'antd';
import Input from '../../../../ui/Input';
import TextArea from '../../../../ui/TextArea';
import { CloseCircleOutlined, PlusOutlined } from '@ant-design/icons';

const Option = Select.Option;

const RoomTypeAdd = (props: any) => {
  const [NbedType, setNbedType] = useState<Array<{}>>([{}]);
  const [sizeValue, setSizeValue] = useState<string>();

  useEffect(
    () => {
      props.currentForm.setFieldsValue({ detail: { beds: NbedType } });
      props.addValidateFieldsError();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    props.addValidateFieldsError();
  }, [NbedType]);

  const addBedType = () => {
    let currentValues = props.currentForm.getFieldsValue(true);
    currentValues = currentValues.detail.beds;
    if (currentValues.length < 5) {
      let s = [...currentValues];
      s.push({ bedtype: '', noofbeds: '' });
      setNbedType(s);
      props.currentForm.setFieldsValue({ detail: { beds: s } });
    }
  };
  const deleteBedType = (i: number) => {
    let currentValues = props.currentForm.getFieldsValue(true);
    currentValues = currentValues.detail.beds;
    if (currentValues.length > 1) {
      let s = [...currentValues];
      s.splice(i, 1);
      setNbedType(s);
      props.currentForm.setFieldsValue({ detail: { beds: s } });
    }
  };

  const getBeds = () => {
    return NbedType.map((item, index) => {
      return (
        <Row
          gutter={24}
          key={index}
        >
          <Col
            span={7}
            className="col-margin"
          >
            <Form.Item
              label={`Bed Type ${index + 1}`}
              name={['detail', 'beds', index, 'bedtype']}
              rules={[{ required: true, message: 'This field is required' }]}
            >
              <Select allowClear showSearch>
                {props.bedType.length &&
                  props.bedType.map((item: { codeName: string }, i: number) => {
                    return (
                      <Option
                        key={i}
                        value={item.codeName}
                      >
                        {item.codeName}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
          </Col>
          <Col
            span={7}
            className="col-margin"
          >
            <Form.Item
              label={`Number of Beds ${index + 1}`}
              name={['detail', 'beds', index, 'noofbeds']}
              rules={[
                { required: true, message: 'This field is required' },
                {
                  pattern: /^\+?\d+$/,
                  message: 'This field should be a number',
                },
              ]}
            >
              <Input />
            </Form.Item>
            {NbedType.length < 5 && index + 1 === NbedType.length ? (
              <div>
                <Button
                  type="link"
                  onClick={() => {
                    addBedType();
                  }}
                  icon={<PlusOutlined />}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: '#fff',
                    float: 'right',
                  }}
                >
                  {`Add Bed Type ${NbedType.length + 1}`}
                </Button>
              </div>
            ) : null}
          </Col>
          {NbedType.length > 1 && (
            <CloseCircleOutlined
              className="panel-btn"
              onClick={() => deleteBedType(index)}
            />
          )}
        </Row>
      );
    });
  };

  return (
    <>
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item
            label="Room ID"
            name="id"
            rules={[
              { required: true, message: 'This field is required' },
              {
                max: 64,
                message: 'You have reached the max character length of 64',
              },
            ]}
          >
            <Input maxLength={64} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Room Type or Class"
            name="type"
          >
            <Select allowClear showSearch>
              <Option value="Room Type">Room Type</Option>
              <Option value="Room Class">Room Class</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            style={
              props.supplier === 'MGM'
                ? { display: 'inline' }
                : { display: 'none' }
            }
            label="Lanyon Room Type"
            name={['detail', 'lanyonType']}
            rules={[
              {
                required: props.supplier === 'MGM',
                message: 'This field is required',
              },
            ]}
          >
            <Select allowClear showSearch>
              {props.lanyonRoomTypes.map((item: any) => {
                return (
                  <Option
                    key={item.id}
                    value={item.value}
                  >
                    {item.value}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            label="Room Type Name"
            name="name"
            rules={[
              { required: true, message: 'This field is required' },
              {
                max: 128,
                message: 'You have reached the max character length of 128',
              },
            ]}
          >
            <Input maxLength={128} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item
            label="Maximum Occupancy"
            name="maxoccupancy"
            rules={[
              { required: true, message: 'This field is required' },
              { pattern: /^\+?\d+$/, message: 'This field should be a number' },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Minimum Occupancy"
            name="minoccupancy"
            rules={[
              { pattern: /^\+?\d+$/, message: 'This field should be a number' },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item
            label="Maximum Adults"
            name="maxadults"
            rules={[
              { pattern: /^\+?\d+$/, message: 'This field should be a number' },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Maximum Children"
            name="maxchildren"
            rules={[
              { required: true, message: 'This field is required' },
              { pattern: /^\+?\d+$/, message: 'This field should be a number' },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            name="description"
            label="Description"
            rules={[
              { required: true, message: 'This field is required' },
              {
                max: 2000,
                message: 'You have reached the max character length of 2000',
              },
            ]}
          >
            <TextArea
              maxLength={2000}
              minRows={3}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col
          span={7}
          className="col-margin"
        >
          <Form.Item
            label="Segment Category"
            name={['detail', 'segmentcat']}
          >
            <Select allowClear showSearch>
              {props.segData.length &&
                props.segData.map((item: any, i: number) => {
                  return (
                    <Option
                      key={i}
                      value={item.codeName}
                    >
                      {item.codeName}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <Form.Item
            label="Location Category"
            name={['detail', 'locationcat']}
          >
            <Select allowClear showSearch>
              {props.locData.length &&
                props.locData.map((item: any, i: number) => {
                  return (
                    <Option
                      key={i}
                      value={item.codeName}
                    >
                      {item.codeName}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <Form.Item
            label="Size"
            name={['detail', 'size']}
            rules={[
              { required: false, message: 'This field is required' },
              {
                pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                message: 'This field should be a number',
              },
            ]}
          >
            <Input onChange={(e) => setSizeValue(e.target.value)} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col
          span={7}
          className="col-margin"
        >
          <Form.Item
            label="Measurements"
            name={['detail', 'measurement']}
            rules={[
              {
                required: sizeValue ? sizeValue.length > 0 : false,
                message: 'This field is required',
              },
            ]}
          >
            <Select allowClear showSearch>
              {props.measurementOpt.map((item: string, i: number) => {
                return (
                  <Option
                    key={i}
                    value={item}
                  >
                    {item}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <Form.Item
            label="Room View"
            name={['detail', 'roomview']}
          >
            <Select allowClear showSearch>
              {props.romview.length &&
                props.romview.map((item: any, i: number) => {
                  return (
                    <Option
                      key={i}
                      value={item.codeName}
                    >
                      {item.codeName}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <Form.Item
            label="Accessible Indicator"
            name={['detail', 'accesibleindicator']}
          >
            <Select allowClear showSearch>
              <Option value="Yes">Yes</Option>
              <Option value="No">No</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col
          span={7}
          className="col-margin"
        >
          <Form.Item
            label="Number of Bedrooms"
            name={['detail', 'noofbedrooms']}
            rules={[
              { pattern: /^\+?\d+$/, message: 'This field should be a number' },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <Form.Item
            label="Number of Bathrooms"
            name={['detail', 'numberofbathrooms']}
          >
            <Select allowClear showSearch>
              {props.NoBathroomOpt.map((item: string, i: number) => {
                return (
                  <Option
                    key={i}
                    value={item}
                  >
                    {item}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <Form.Item
            label="Non-Smoking"
            name={['detail', 'nonsmoking']}
            rules={[{ required: true, message: 'This field is required' }]}
          >
            <Select allowClear showSearch>
              <Option value="Yes">Yes</Option>
              <Option value="No">No</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      {getBeds()}

      <Row gutter={24}>
        <Col
          span={7}
          className="col-margin"
        >
          <Form.Item
            label="Maximum Rollaways"
            name={['detail', 'maxrollaway']}
            rules={[
              { required: true, message: 'This field is required' },
              { pattern: /^\+?\d+$/, message: 'This field should be a number' },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <Form.Item
            label="Maximum Cribs"
            name={['detail', 'maxcrib']}
            rules={[
              { pattern: /^\+?\d+$/, message: 'This field should be a number' },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default RoomTypeAdd;
